import request from "@/utils/request";

/**
 * 获取友情链接列表（仅启用，按排序）
 */
export function getFriendLinkList() {
  return request.get("/api/friend-link/list");
}
